import { amountWithoutDecimalPlaces } from '@docsndata/stripe-cloud-functions-api';
import { writable } from "svelte/store";
import dayjs from "dayjs";
export function slotOption(id, label) {
    return { id, label };
}
export const serviceId = writable(null);
export const inviteId = writable(null);
export const earliestPossibleDateOnLhsOfDisplay = new Date();
export const dateOnLhsOfDisplay = writable(earliestPossibleDateOnLhsOfDisplay);
export function addDays(d, days) {
    return dayjs(d).add(days, "day").toDate();
}
export function availabilityForDate(dateKey, availableTimeSlotsByDate, pricedServicesByDate) {
    const timeSlotsForDate = availableTimeSlotsByDate[dateKey];
    const priceForDate = pricedServicesByDate[dateKey];
    if (timeSlotsForDate === undefined || priceForDate === undefined) {
        return null;
    }
    if (priceForDate.length !== 1) {
        throw new Error(`Expected exactly 1 priced service for date ${dateKey}, got ${priceForDate.length}`);
    }
    const thePricedService = priceForDate[0];
    const amount = amountWithoutDecimalPlaces(parseInt((thePricedService.price * 100).toFixed()));
    return {
        id: dateKey,
        productId: thePricedService.serviceId,
        label: thePricedService.price === 0 ? "" : "£ " + thePricedService.price,
        amount: amount,
        options: timeSlotsForDate.map(ts => slotOption(ts, ts))
    };
}
